import React, { useEffect, useState } from 'react';
import usePushNotifications from 'hooks/usePushNotifications';

// #ux-redesign: SweetAlert → ConfirmDialog DS
import { toast, ConfirmDialog } from 'components/ds';
import PushNotificationService from 'services/PushNotificationsService';
import { FormGroup, Button } from 'reactstrap';
import { useTranslate } from 'react-translate';

import { useSelector } from 'react-redux';
import nativeSender from 'helpers/nativeSender';

export default function PushNotification() {
  const t = useTranslate('settings');
  // #ux-redesign: estado del ConfirmDialog para unsubscribe
  const [unsubscribeOpen, setUnsubscribeOpen] = useState(false);
  const {
    pushNotificationSupported,
    userSubscription,
    askUserPermission,
    error,
  } = usePushNotifications();

  const { nativeWebView } = useSelector((state) => state.commonReducer);

  const handleUnsubscribe = () => setUnsubscribeOpen(true);

  const onConfirmUnsubscribe = async () => {
    try {
      if (userSubscription) {
        PushNotificationService.pushUnsusbcribe(userSubscription);
        toast.success(t('unsubscription-success'));
      }
    } catch (e) {
      toast.error(e.message);
    } finally {
      setUnsubscribeOpen(false);
    }
  };
  useEffect(() => {
    if (error) {
      toast.error(error.message);
    }
  }, [error]);

  if (!pushNotificationSupported && !nativeWebView) {
    return (
      <div className="setting-section">
        <h5 className="general-card-subtitle">{t('notifications-title')}</h5>
        <p>{t('notifications-unsupported')}</p>
      </div>
    );
  }

  return (
    <div className="setting-section">
      <ConfirmDialog
        isOpen={unsubscribeOpen}
        title={t('are-you-sure')}
        description={t("cancel-subscription-prompt")}
        confirmLabel={t('btn-unsubscribe')}
        cancelLabel={t('btn-cancel')}
        variant="danger"
        onConfirm={onConfirmUnsubscribe}
        onCancel={() => setUnsubscribeOpen(false)}
      />
      <h5 className="general-card-subtitle">{t('notifications-title')}</h5>
      <FormGroup>
        <div className="notification-section">
          {/* #ux-redesign: mostrar SOLO un botón según el estado actual de la
              suscripción. Antes se mostraban Enable + Disable a la vez, lo
              cual confunde (¿en qué estado estoy ahora?).
              - userSubscription presente → Disable
              - userSubscription ausente   → Enable
              En nativeWebView no podemos saber el estado real (lo maneja la
              app), así que mostramos las dos opciones como fallback. */}
          {nativeWebView ? (
            <>
              <Button
                color="info"
                size="sm"
                name="bnt-suscribe-push"
                onClick={() => {
                  nativeSender.send('SUBSCRIBE');
                  toast.success(t('subscription-success'));
                }}
              >
                {t('enable-notifications')}
              </Button>
              <Button
                color="primary"
                type="button"
                size="sm"
                name="bnt-unsuscribe-push"
                onClick={() => {
                  nativeSender.send('UNSUBSCRIBE');
                  toast.success(t('unsubscription-success'));
                }}
              >
                {t('disable-notifications')}
              </Button>
            </>
          ) : userSubscription ? (
            <Button
              color="primary"
              type="button"
              size="sm"
              name="bnt-unsuscribe-push"
              onClick={handleUnsubscribe}
            >
              {t('disable-notifications')}
            </Button>
          ) : (
            <Button
              color="info"
              size="sm"
              name="bnt-suscribe-push"
              onClick={askUserPermission}
            >
              {t('enable-notifications')}
            </Button>
          )}
        </div>
      </FormGroup>
    </div>
  );
}
